// Quantify based on the staffel selection Simple Version, without Cart CHECK
// FOR CART CHECK see quantity-staffel-complex.js
export const QuantityStaffel = (containerId) => {
    const parent = containerId
        ? document.querySelector(`#${containerId}`)
        : document;
    const staffels = parent.querySelector("#staffels[data-id]");
    const variationParent = parent.querySelector(
        ".single_variation_wrap .woocommerce-variation-price .price",
    );
    const observer = new MutationObserver((mutationsList) => {
        observer.disconnect();
        // mutationsList.forEach((mutation) => {
        //     if (mutation.type === "childList") {
        //         if (parent) {
        //             var variationParent = parent.querySelector(
        //                 ".single_variation_wrap .woocommerce-variation-price .price",
        //             );
        //             if (variationParent) {
        //                 var del = parent.querySelector("del bdi");
        //                 // var price = parent.querySelector("ins bdi");
        //                 if (del) {
        //                     sendValue(variationParent, del.innerText);
        //                 } else {
        //                     sendValue(variationParent);
        //                 }
        //                 observer.disconnect();
        //             }
        //         }
        //     }
        // });
    });

    observer.observe(parent, { childList: true, subtree: true });
    if (!staffels) return;

    const quantityInput = parent.querySelector(".cart input[name='quantity']");
    const variations_price = parent.querySelector("#pa_kleur");

    const sendValue = (value, original) => {
        observer.observe(parent, { childList: true, subtree: true });
        const newPrice = original
            ? original
            : staffels.querySelector(
                  ".staffel.active .woocommerce-Price-amount.amount bdi",
              )?.textContent;
        updatePriceHtml(parent, quantityInput.value, newPrice, value);
        observer.observe(parent, { childList: true, subtree: true });
    };

    const updateActiveStaffel = () => {
        const totalVal = parseInt(quantityInput.value, 10) || 0;

        staffels.querySelectorAll(".staffel").forEach((el) => {
            const dataValue = parseInt(el.getAttribute("data-value"), 10);
            const dataMax = parseInt(el.getAttribute("data-max"), 10);
            el.classList.toggle(
                "active",
                totalVal >= dataValue && (!dataMax || totalVal <= dataMax),
            );
        });
        if (containerId) {
            sendValue();
        }
    };

    staffels.querySelectorAll(".staffel").forEach((el) => {
        el.addEventListener("click", () => {
            staffels
                .querySelectorAll(".staffel")
                .forEach((otherEl) => otherEl.classList.remove("active"));
            el.classList.add("active");
            const dataValue = parseInt(el.getAttribute("data-value"), 10);
            quantityInput.value = dataValue;
            jQuery(quantityInput).val(dataValue).trigger("change");

            el.scrollIntoView({
                alignToTop: true,
                behavior: "smooth",
                block: "center",
                inline: "nearest",
            });
            if (containerId) {
                sendValue();
            }
        });
    });

    quantityInput.addEventListener("change", () => {
        updateActiveStaffel();
        if (containerId) {
            sendValue();
        }
    });
    if (!variations_price) return;
    variations_price.addEventListener("click", () => {
        updateActiveStaffel();
        sendValue();
    });
    updateActiveStaffel();
};

function updatePriceHtml(parent, quantity, newPrice, variationParent) {
    const priceElement = parent.querySelector("p.price");
    const priceChild = priceElement.querySelector("ins");
    const price = priceElement.querySelector(
        "ins .woocommerce-Price-amount.amount bdi",
    );
    if (!price) return;
    // cleanupPrice
    if (priceChild.innerHTML.includes("–")) {
        priceChild.innerHTML = priceChild.innerHTML.replace("–", "");

        priceChild.querySelectorAll("span").forEach((el, i) => {
            if (i > 0) {
                el.remove();
            }
        });
    }

    if (variationParent) {
        variationParent.innerHTML = variationParent.innerHTML.replace(
            "&nbsp;",
            "",
        );
        var thePrice = variationParent.innerHTML;

        priceElement.innerHTML = thePrice;

        const discountPercentage = parseFloat(
            parent
                .querySelector(".discount-percentage")
                ?.textContent?.match(/\d+(\.\d+)?/)?.[0],
        );

        // const discountstaffelAmount = parseFloat(
        //     parent
        //         .querySelector(
        //             "#staffels[data-id] .staffel.active .awdr_bulk_discounted_value",
        //         )
        //         ?.textContent?.match(/\d+(\.\d+)?/)?.[0],
        // );
        var newPrice = newPrice.replace(",", ".");
        var newPriceFloat = parseFloat(newPrice);
        // var newPriceFloat = newPriceFloat * (discountstaffelAmount / 100);
        var discountedPrice = newPriceFloat * (discountPercentage / 100);

        var thePrice = newPriceFloat - discountedPrice; // add * quantity to get total price
        price.textContent = thePrice.toFixed(2);
    } else {
        const discountPercentage = parseFloat(
            parent
                .querySelector(".discount-percentage")
                ?.textContent?.match(/\d+(\.\d+)?/)?.[0],
        );
        const discountstaffelAmount = parent.querySelector(
            ".awdr_bulk_discounted_value",
        ).textContent;
        var newPrice = newPrice.replace(",", ".");
        var newPriceFloat = parseFloat(newPrice);
        var discountedPrice = newPriceFloat * (discountPercentage / 100);

        var thePrice = newPriceFloat - discountedPrice; // add * quantity to get total price
        price.textContent = thePrice.toFixed(2);
    }
}
